import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container, Card, Alert, Row, Col } from 'react-bootstrap';

const SubDeptEditModel = () => {
     const { id } = useParams();
     const navigate = useNavigate();
     const [formData, setFormData] = useState({
          sub_dept: '',
          status: 'A'
     });
     const [error, setError] = useState(null);
     const [success, setSuccess] = useState(null);
     const [loading, setLoading] = useState(true);
     const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://internalhrms.vdcapp.in/backend/api';

     useEffect(() => {
          fetchSubDept();
     }, [id]);

     const fetchSubDept = async () => {
          try {
               const token = localStorage.getItem('token');
               const response = await fetch(`${BASE_URL}/getSubDeptById/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
               });
               const result = await response.json();
               if (result.status && result.data) {
                    setFormData({
                         sub_dept: result.data.sub_dept || '',
                         status: result.data.status || 'A'
                    });
               } else {
                    setError('Sub department not found');
               }
          } catch (error) {
               setError('Error fetching sub department: ' + error.message);
          } finally {
               setLoading(false);
          }
     };

     const handleSubmit = async (e) => {
          e.preventDefault();
          try {
               const token = localStorage.getItem('token');
               const response = await fetch(`${BASE_URL}/updateSubDeptById/${id}`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                         sub_dept: formData.sub_dept,
                         status: formData.status
                    })
               });
               const result = await response.json();
               if (result.status) {
                    setSuccess('Sub department updated successfully!');
                    setTimeout(() => navigate('/subdept'), 2000);
               } else {
                    setError(result.message || 'Failed to update sub department');
               }
          } catch (error) {
               setError('Error: ' + error.message);
          }
     };

     if (loading) return <Container className="py-4"><div className="text-center">Loading...</div></Container>;

     return (
          <Container className="py-4">
               <Card>
                    <Card.Header className="bg-primary text-white">
                         <h4>Edit Sub Department</h4>
                    </Card.Header>
                    <Card.Body>
                         {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
                         {success && <Alert variant="success">{success}</Alert>}

                         <Form onSubmit={handleSubmit}>
                              <Row>
                                   <Col md={6}>
                                        <Form.Group className="mb-3">
                                             <Form.Label>Sub Department Name *</Form.Label>
                                             <Form.Control
                                                  type="text"
                                                  value={formData.sub_dept}
                                                  onChange={(e) => setFormData({ ...formData, sub_dept: e.target.value })}
                                                  required
                                             />
                                        </Form.Group>
                                   </Col>
                                   <Col md={6}>
                                        <Form.Group className="mb-3">
                                             <Form.Label>Status</Form.Label>
                                             <Form.Select
                                                  value={formData.status}
                                                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                             >
                                                  <option value="A">Active</option>
                                                  <option value="I">Inactive</option>
                                             </Form.Select>
                                        </Form.Group>
                                   </Col>
                              </Row>

                              <div className="d-flex gap-2">
                                   <Button variant="primary" type="submit">Update</Button>
                                   <Button variant="secondary" onClick={() => navigate('/subdept')}>Cancel</Button>
                              </div>
                         </Form>
                    </Card.Body>
               </Card>
          </Container>
     );
};

export default SubDeptEditModel;